<template>
    <div style="height: 100vh; padding: 15px">
        <div v-if="render_type == 'all'" class="app-content">
            <a-card title="ตรวจเช็ครถก่อนออกปฎิบัติงาน (Roll call)">
                <template v-if="!business" #extra>
                    <a-space>
                        <a-button style="display: flex" type="primary" size="large" @click="show_export_rollcall=true">
                            ออกรายงาน Roll call
                        </a-button>
                        <a-col style="margin-left: 1rem;display: flex;align-items: center">
                            <a-switch v-model:checked="require_rollcall" :disabled="!editable"/>
                            <span style="margin-left: 5px">อนุญาติเฉพาะรถผ่าน RollCall</span>
                        </a-col>
                        <a-select v-model:value="selected_date_filter" style="width: 150px;">
                            <a-select-option value="issue_date" key="1" selected>วันที่แจ้งตรวจสอบ</a-select-option>
                            <a-select-option value="check_end" key="2">วันที่แจ้งตรวจเสร็จสิ้น</a-select-option>
                        </a-select>
                        <a-range-picker
                            v-model:value="roll_call_range"
                            :show-time="{ format: 'HH:mm' }"
                            format="DD/MM/YYYY HH:mm"
                            :placeholder="['เริ่มต้น', 'สิ้นสุด']"
                            :minuteStep="1"
                        />
                        <router-link v-if="editable" :to="`/app/roll-call/add`">
                            <a-button style="display: flex" type="primary" size="large">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                เพิ่มรายการ Roll call
                            </a-button>
                        </router-link>
                    </a-space>
                </template>
                <div v-if='!business'>
                    <a-row type="flex" style="align-items: end;">
                    <a-col flex="1 0" style="margin-right:1rem">
                        <a-input-search v-model:value="search_car" :placeholder="`ค้นหา ทะเบียนรถ`"
                            enter-button="ค้นหา" />
                    </a-col>
                    <a-col flex="1 0" style="margin-right:1rem">
                        <label>บริษัทรถ:</label>
                        <a-select style="width: 100%" v-model:value="search_car_company" placeholder="เลือกบริษัทรถ"
                            :dropdownMatchSelectWidth="false">
                            <a-select-option :value="null">ทั้งหมด</a-select-option>
                            <a-select-option v-for="{ fullname, id }, i in car_company_list" :key="i" :value="fullname">
                                {{ fullname }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col flex="1 0" style="margin-right:1rem">
                        <label>รถ:</label>
                        <a-select style="width: 100%" v-model:value="search_car" placeholder="เลือกรถ"
                            :dropdownMatchSelectWidth="false">
                            <a-select-option :value="null">ทั้งหมด</a-select-option>
                            <a-select-option v-for="{ plate_no, id }, i in car_list" :key="i" :value="plate_no">
                                {{ plate_no }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col flex="1 0" style="margin-right:1rem">
                        <label>สถานะ:</label>
                        <a-select style="width: 100%" v-model:value="search_status" placeholder="เลือกสถานะ"
                            :dropdownMatchSelectWidth="false">
                            <a-select-option :value="null">ทั้งหมด</a-select-option>
                            <a-select-option :value="1">ทำแล้ว</a-select-option>
                            <a-select-option :value="2">ยังไม่ได้ทำ</a-select-option>
                        </a-select>
                    </a-col>
                    <a-button @click="clear_search()" type="dashed">CLEAR</a-button>
                </a-row>
                </div>    
                <div v-if="business">
                    <a-row style="display: flex; justify-content: flex-end;">
                    <a-space>
                        <router-link v-if="editable" :to="`/app/roll-call/add`">
                            <a-button style="display: flex" type="primary" size="large">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                เพิ่มรายการ Roll call
                            </a-button>
                        </router-link>
                        <a-button ref="import_file" @click="show_export_rollcall=true">
                            <span class="material-symbols-outlined">download</span>Export
                        </a-button>
                    </a-space>
                </a-row>
                <div style="display: flex; justify-content: space-between; align-items: center; ">
                    <div style="display: flex; align-items: center; gap: 1rem;">
                        <a-select style="width: 150px" v-model:value="search_car_company" placeholder="เลือกบริษัทรถ"
                            :dropdownMatchSelectWidth="false">
                            <a-select-option v-for="{ fullname, id }, i in car_company_list" :key="i" :value="fullname">
                                {{ fullname }}
                            </a-select-option>
                        </a-select>
                        <a-input-search style="width: 250px;" v-model:value="search_car" :placeholder="`ค้นหา ทะเบียนรถ เบอร์รถ และชื่อพนักงาน`"
                            enter-button="ค้นหา" />
                        <a-button @click="clear_search()" type="dashed">CLEAR</a-button>
                        <a-select style="width: 150px;" v-model:value="search_status" placeholder="เลือกสถานะ"
                            :dropdownMatchSelectWidth="false">
                            <a-select-option v-for="{ name, id }, i in status_list" :key="i" :value="id" >
                                {{ name }}
                            </a-select-option>
                        </a-select>
                        <!-- <a-switch v-model:checked="require_rollcall" :disabled="!editable"/>
                        <span style="margin-left: 5px;width: 170px;">อนุญาติเฉพาะรถผ่าน RollCall</span> -->
                        <a-select style="width: 150px;" v-model:value="selected_date_filter"
                            :dropdownMatchSelectWidth="false">
                            <a-select-option value="issue_date" key="1" selected>วันที่แจ้งตรวจสอบ</a-select-option>
                            <a-select-option value="check_end" key="2">วันที่แจ้งตรวจเสร็จสิ้น</a-select-option>
                        </a-select>
                            <a-range-picker
                            v-model:value="roll_call_range"
                            format="DD/MM/YYYY"
                            style="width: 300px;"
                            :placeholder="['เริ่มต้น', 'สิ้นสุด']"
                            :minuteStep="1"
                        />
                        </div>
                    </div>
                </div>
                <br>
                <a-row>
                    <a-table :columns="([
                        {
                            title: 'ทะเบียนรถ',
                            dataIndex: 'car',
                            key: 'car',
                            width: 100,
                            align: 'center',
                        }, {
                            title: 'บริษัท',
                            dataIndex: 'car_company',
                            key: 'car_company',
                            width: 100,
                            align: 'center',
                        }, 
                        {
                            title: 'สาเหตุการเข้ารับการตรวจ',
                            dataIndex: 'reason',
                            key: 'reason',
                            width: 225,
                            align: 'center',
                        },
                        {
                            title: 'ชื่อพนักงานขับรถ',
                            dataIndex: 'driver_name',
                            key: 'driver_name',
                            width: 200,
                            align: 'center',
                        },
                        {
                            title: 'วันที่แจ้งตรวจสอบ',
                            dataIndex: 'issue_date',
                            key: 'issue_date',
                            width: 175,
                            align: 'center',
                            sorter: {
                                compare: (a, b) => new Date(a.issue_date) - new Date(b.issue_date),
                                multiple: 2,
                            }
                        }, 
                        // {
                        //     title: 'วันที่รับแจ้งตรวจ',
                        //     dataIndex: 'check_start',
                        //     key: 'check_start',
                        //     width: 175,
                        //     align: 'center',
                        //     sorter: {
                        //         compare: (a, b) => new Date(a.check_start) - new Date(b.check_start),
                        //         multiple: 3,
                        //     }
                        // }, 
                        {
                            title: 'วันที่ตรวจเสร็จสิ้น',
                            dataIndex: 'check_end',
                            key: 'check_end',
                            width: 175,
                            align: 'center',
                            sorter: {
                                compare: (a, b) => new Date(a.check_end) - new Date(b.check_end),
                                multiple: 1,
                            }
                        }, 
                        {
                            title: 'ขื่อผู้ตรวจ',
                            dataIndex: 'inspector',
                            key: 'inspector',
                            width: 200,
                            align: 'center',
                        },
                        {
                            title: 'สถานะ',
                            dataIndex: 'status',
                            key: 'status',
                            width: 125,
                            align: 'center',
                        },
                        {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 150,
                            align: 'center',
                            fixed: 'right'
                        }
                    ].filter(({ key }) => editable ? true : key != 'id'))" :pagination="false" :data-source="filtered_list(roll_call_list)" bordered size="small"
                        :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'id'">
                                <a-tooltip>
                                    <template #title>อัพเดทข้อมูล</template>
                                    <a @click="show_update_progress(record.id)"
                                        ><span style="font-size: 14px" class="material-symbols-outlined"
                                        >update</span
                                        ></a
                                    >
                                </a-tooltip>
                                <a-divider type="vertical"></a-divider>
                                <router-link 
                                    :to="`/app/roll-call/${record.id}`"
                                >
                                    <span style="font-size: 14px"
                                        class="material-symbols-outlined"
                                    >
                                        drive_file_rename_outline
                                    </span>
                                </router-link>
                                <a-divider type="vertical"></a-divider>
                                <a  
                                    @click="remove_rollcall(record.id)"
                                >
                                    <span style="font-size: 18px"
                                        class="material-symbols-outlined">delete
                                    </span>
                                </a>
                            </template>
                            <template v-else-if="column.key === 'accident_detail'">
                                {{ record.accident_details?.map(({ detail }) => detail).join(', ') }}
                            </template>
                            <template v-else-if="column.key === 'car_company'">
                                {{ record.car_company?.fullname }}
                            </template>
                            <template v-else-if="column.key === 'car'">
                                {{ record.car?.plate_no }}
                            </template>
                            <template v-else-if="column.key === 'status'">
                                <StatusTag
                                    :statusText="statusRollCall(record).txt"
                                    :statusColor="statusRollCall(record).color"
                                />
                            </template>
                            <template v-else-if="column.key === 'check_start' || column.key == 'issue_date' || column.key == 'check_end'">
                                {{ record[column.key] ? render_date(record[column.key]) : '-' }}
                            </template>
                        </template>
                    </a-table>
                </a-row>
            </a-card>
        </div>
        <div v-else class="app-content">
            <a-card title="ตรวจเช็ครถก่อนออกปฎิบัติงาน (Roll call)">
                <template #extra>
                    <a-button style="display: flex" @click="$router.go(-1)" size="large">
                        <template #icon>
                            <span class="material-symbols-outlined">arrow_back_ios</span>
                        </template>
                        ย้อนกลับ
                    </a-button>
                </template>
                <a-form :model="create_roll_call" name="create_roll_call" autocomplete="off" layout="vertical"
                    @finish="submit_create_roll_call" @finishFailed="submit_create_roll_call_failed">
                    <a-collapse v-model:activeKey="activeKey">
                        <a-collapse-panel key="1" header="ข้อมูลที่ต้องการสำหรับตรวจเช็ครถ ">
                            <template #extra>
                                <p v-if="[
                                    create_roll_call.car_company_id,
                                    create_roll_call.car_id,
                                    create_roll_call.issue_date,
                                    // create_roll_call.check_start,
                                    create_roll_call.check_end,
                                    create_roll_call.reason,
                                    // create_roll_call.inspector
                                ].filter(e => e == null).length" style="margin: 0;color: grey">
                                    {{`(ต้องระบุอีก ${[
                                        create_roll_call.car_company_id,
                                        create_roll_call.car_id,
                                        create_roll_call.issue_date,
                                        // create_roll_call.check_start,
                                        create_roll_call.check_end,
                                        // create_roll_call.reason,
                                        // create_roll_call.inspector
                                    ].filter(e => e == null).length})`}}
                                </p>
                            </template>

                            <a-row>
                                <a-col :span="6">
                                    <a-form-item label="บริษัทรถ" name="car_company_id"
                                        :rules="[{ required: true, message: 'โปรดเลือกบริษัทรถ' }]">
                                        <a-select 
                                            v-model:value="create_roll_call.car_company_id"
                                            placeholder="เลือกบริษัท"
                                            @change="clearSubData"
                                            show-search
                                            :filter-option="(input, option) =>
                                                option.label.toLowerCase().includes(input.toLowerCase())"
                                            :options="car_company_list.map(({ id, fullname }) => ({
                                                value: id,
                                                label: fullname
                                            }))">
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="ทะเบียนรถ" name="car_id"
                                        :rules="[{ required: true, message: 'โปรดเลือกทะเบียนรถที่รับการตรวจ' }]">
                                        <a-select 
                                            v-model:value="create_roll_call.car_id" 
                                            placeholder="ทะเบียนรถ"
                                            show-search
                                            :filter-option="(input, option) =>
                                                option.label.toLowerCase().includes(input.toLowerCase())"
                                            :options="carOptionFiltered.map(({ id, plate_no }) => ({
                                                value: id,
                                                label: plate_no
                                            }))"
                                            @change="select_car">
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="ชื่อพนักงานขับรถ">
                                        <a-select 
                                            v-model:value="create_roll_call.driver_name"
                                            placeholder="ชื่อพนักงานขับรถ"
                                            show-search
                                            :filter-option="(input, option) =>
                                                option.label.toLowerCase().includes(input.toLowerCase())"
                                            :options="driverOptionFiltered.map(({ firstname, lastname }) => ({
                                                value: firstname+' '+lastname,
                                                label: firstname+' '+lastname
                                            }))"
                                            @change="licenseCheck"
                                            />
                                    </a-form-item>
                                </a-col>
                                <!-- <a-col :span="6">
                                    <a-form-item label="สาเหตุที่รับการตรวจ" name="reason"
                                        :rules="[{ required: true, message: 'โปรดเลือกสาเหตุที่รับการตรวจ' }]">
                                        <a-input v-model:value="create_roll_call.reason"
                                            placeholder="โปรดระบุสาเหตุที่รับการตรวจ" />
                                    </a-form-item>
                                </a-col> -->
                            </a-row>

                            <a-row>
                                <a-col :span="6">
                                    <a-form-item name="driver_license_no"
                                        :rules="[{ message: 'โปรดกรอกใบอนุญาตขับรถเลขที่' }]">
                                         <template #label>
                                            <div style="display: flex; align-items: center;">
                                            <span>ใบอนุญาตขับรถเลขที่</span>
                                            <a-radio-group 
                                                style="margin-left: 8px;"
                                                v-model:value="is_checked_license">
                                                <a-radio :value="1">มี</a-radio>
                                                <a-radio :value="0">ไม่มี</a-radio>
                                            </a-radio-group>
                                            </div>
                                        </template>
                                         <a-input v-model:value="create_roll_call.driver_license_no"
                                            :disabled="!(is_checked_license == 1)"
                                            placeholder="ใบอนุญาตขับรถเลขที่" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="ชนิดใบอนุญาตขับรถ" name="driving_license_type_id">
                                        <a-select v-model:value="create_roll_call.driving_license_type_id" placeholder="ชนิดใบอนุญาตขับรถ">
                                            <a-select-option v-for="{ id, name } in driving_license_type_list" :key="id"
                                                :value="id">{{ name }}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>

                                <!-- <a-col :span="6">
                                    <a-form-item label="เวลาเข้ารับการตรวจ" name="check_start"
                                        :rules="[{ required: true, message: 'โปรดเลือกเวลาเข้ารับการตรวจ :' }]">
                                        <a-date-picker v-model:value="create_roll_call.check_start"
                                            placeholder="เวลาเข้ารับการตรวจ" :show-time="{ format: 'HH:mm' }"
                                            format="DD/MM/YYYY HH:mm" :minuteStep="1" :locale="lang_th" />
                                    </a-form-item>
                                </a-col> -->
                                <a-col :span="6">
                                    <a-form-item 
                                        label="ชื่อผู้ตรวจ" 
                                        name="inspector"
                                    >
                                        <a-input v-model:value="create_roll_call.inspector"
                                            placeholder="ชื่อผู้ตรวจ"
                                            />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-row>
                                <a-col :span="6">
                                    <a-form-item 
                                        label="สถานที่ตรวจสอบ" 
                                        name="inspect_location"
                                    >
                                        <a-input
                                            v-model:value="create_roll_call.inspect_location"
                                            ref="inspect_location"
                                            id="inspect_location"
                                            @change="initMap('inspect_location')"
                                            placeholder="สถานที่ตรวจสอบ"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="วันที่แจ้งตรวจสอบ" name="issue_date"
                                        :rules="[{ required: true, message: 'โปรดเลือกวันที่แจ้งตรวจสอบ :' }]">
                                        <a-date-picker v-model:value="create_roll_call.issue_date"
                                            placeholder="วันที่แจ้งอุบัติเหตุ"
                                            format="DD/MM/YYYY" :minuteStep="1" :locale="lang_th" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="วันที่ตรวจเสร็จสิ้น" name="check_end">
                                        <a-date-picker v-model:value="create_roll_call.check_end"
                                            disabled
                                            placeholder="วันที่ตรวจเสร็จสิ้น"
                                            format="DD/MM/YYYY" :minuteStep="1" :locale="lang_th" />
                                    </a-form-item>
                                </a-col>
                                <!-- <a-col :span="6">
                                    <a-form-item label="ประเภทรภ">
                                        <a-input v-model:value="preview_selected.car_group_name" placeholder="ประเภทรภ"
                                            disabled />
                                    </a-form-item>
                                </a-col> -->
                                <!-- <a-col :span="6">
                                    <a-form-item label="พนักงานบริการประจำรถ"> -->
                                        <!-- <a-input v-model:value="preview_selected.sub_driver_name" -->
                                        <!-- <a-input v-model:value="create_roll_call.main_car_service"
                                            placeholder="พนักงานบริการประจำรถ" />
                                    </a-form-item>
                                </a-col> -->
                            </a-row>

                        </a-collapse-panel>

                        <a-collapse-panel key="2" header="พนักงานขับรถ และพนักงานประจำรถ">
                            <a-table :columns="[
                                {
                                    title: 'ลำดับ',
                                    dataIndex: 'index',
                                    key: 'index',
                                    width: 50,
                                    align: 'center',
                                }, {
                                    title: 'รายละเอียด',
                                    dataIndex: 'detail',
                                    key: 'detail',
                                    width: 130
                                }, {
                                    title: 'พนักงานขับรถ',
                                    dataIndex: 'driver',
                                    key: 'driver',
                                    width: 150,
                                    align: 'start',
                                }, {
                                    title: 'พนักงานบริการประจำรถ',
                                    dataIndex: 'sub_driver',
                                    key: 'sub_driver',
                                    width: 150,
                                    align: 'center',
                                }, {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 40,
                                    align: 'center',
                                    fixed: 'right'
                                }
                            ]" :pagination="false" :data-source="driver_section" bordered size="small"
                                :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'id'">
                                        <a @click="clear_row([`driver${record.index}`, `sub_driver${record.index}`],record.index,'driver')"><span
                                                style="font-size: 24px; color: black;"
                                                class="material-symbols-outlined">backspace</span></a>
                                    </template>
                                    <template v-else-if="column.key === 'driver'">
                                        <a-upload v-model:file-list="record.driver.fileList" list-type="picture"
                                            class="upload-list-inline"
                                            :before-upload="beforeUpload"
                                            @change="upload_files($event, `driver${record.index}_photo`)"
                                            method="GET"
                                            @remove="remove_uploaded_file(`driver${record.index}_photo`)"
                                            :openFileDialogOnClick="openFileDialogOnClick">
                                            <a-space>
                                                <a-select v-if="record.index < 3"
                                                    v-model:value="create_roll_call[`driver${record.index}_is_pass`]"
                                                    style="width: 100px">
                                                    <a-select-option :value="0">ไม่ผ่าน</a-select-option>
                                                    <a-select-option :value="1">ผ่าน</a-select-option>
                                                </a-select>
                                                <a-input-number v-else
                                                    v-model:value="create_roll_call[`driver${record.index}_amount`]"
                                                    placeholder="กรอกตัวเลข" style="width: 100px" />
                                                <a-input-number v-if="record.index == 5"
                                                    v-model:value="create_roll_call[`driver${record.index}_bp`]"
                                                    placeholder="กรอกตัวเลข" style="width: 100px"/>
                                                <a-input
                                                    v-model:value="create_roll_call[`driver${record.index}_remark`]"
                                                    placeholder="รายละเอียดอื่นๆ" :disabled="create_roll_call[`driver${record.index}_is_pass`] == 1" />
                                                <a-button @click="openFileDialogOnClick = true" :disabled="create_roll_call[`driver${record.index}_is_pass`] == 1">
                                                    <span style="font-size: 20px"
                                                        class="material-symbols-outlined">photo_camera</span>
                                                </a-button>
                                            </a-space>
                                        </a-upload>
                                    </template>
                                    <template v-else-if="column.key === 'sub_driver'">
                                        <a-upload v-model:file-list="record.sub_driver.fileList" list-type="picture"
                                            class="upload-list-inline" 
                                            :before-upload="beforeUpload"
                                            @change="upload_files($event, `sub_driver${record.index}_photo`)"
                                            method="GET"
                                            @remove="remove_uploaded_file(`sub_driver${record.index}_photo`)"
                                            :openFileDialogOnClick="openFileDialogOnClick">
                                            <a-space v-if="record.index != 5">
                                                <a-select v-if="record.index < 3"
                                                    v-model:value="create_roll_call[`sub_driver${record.index}_is_pass`]"
                                                     style="width: 100px">
                                                    <a-select-option :value="0">ไม่ผ่าน</a-select-option>
                                                    <a-select-option :value="1">ผ่าน</a-select-option>
                                                </a-select>
                                                <a-input-number v-else
                                                    v-model:value="create_roll_call[`sub_driver${record.index}_amount`]"
                                                    placeholder="กรอกตัวเลข" style="width: 100px" :disabled="create_roll_call[`sub_driver${record.index}_is_pass`] == 1" />
                                                <a-input
                                                    v-model:value="create_roll_call[`sub_driver${record.index}_remark`]"
                                                    placeholder="รายละเอียดอื่นๆ" :disabled="create_roll_call[`sub_driver${record.index}_is_pass`] == 1" />
                                                <a-button @click="openFileDialogOnClick = true" :disabled="create_roll_call[`sub_driver${record.index}_is_pass`] == 1">
                                                    <span style="font-size: 20px"
                                                        class="material-symbols-outlined">photo_camera</span>
                                                </a-button>
                                            </a-space>
                                        </a-upload>
                                    </template>
                                </template>
                            </a-table>
                        </a-collapse-panel>

                        <a-collapse-panel key="3" v-if="!business" header="Cleanliness & Health & Safety">
                            <a-table :columns="[
                                {
                                    title: 'ลำดับ',
                                    dataIndex: 'index',
                                    key: 'index',
                                    width: 25,
                                    align: 'center',
                                }, {
                                    title: 'Cleanliness',
                                    dataIndex: 'clean',
                                    key: 'clean',
                                    width: 250,
                                    align: 'center',
                                }, {
                                    title: 'Health',
                                    dataIndex: 'health',
                                    key: 'health',
                                    width: 250,
                                    align: 'center',
                                }, {
                                    title: 'Safety',
                                    dataIndex: 'safe',
                                    key: 'safe',
                                    width: 250,
                                    align: 'center',
                                }, {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 40,
                                    align: 'center',
                                    fixed: 'right'
                                }
                            ]" :pagination="false" :data-source="cleanliness_section" bordered size="small"
                                :scroll="{ x: 1750 }">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'id'">
                                        <a @click="clear_row([`clean${record.index}`, `health${record.index}`, `safe${record.index}`],record.index,'clean')"><span style="font-size: 24px;color: black;"
                                                class="material-symbols-outlined">backspace</span></a>
                                    </template>
                                    <template v-else-if="column.key == 'index'">
                                        {{ record.index }}
                                    </template>
                                    <template v-else>
                                        <div style="display: flex; justify-content: space-between; align-items: center">
                                            <span>{{ record[column.key].title }}</span>
                                            <a-upload v-model:file-list="record[column.key].fileList"
                                                list-type="picture" class="upload-list-inline"
                                                :before-upload="beforeUpload"
                                                @change="upload_files($event, `${column.key}${record.index}_photo`)"
                                                method="GET"
                                                @remove="remove_uploaded_file(`${column.key}${record.index}_photo`)"
                                                :openFileDialogOnClick="openFileDialogOnClick">
                                                <a-space>
                                                    <a-select v-model:value="create_roll_call[`${column.key}${record.index}_is_pass`]"
                                                        style="width: 100px">
                                                        <a-select-option :value="0">ไม่ผ่าน</a-select-option>
                                                        <a-select-option :value="1">ผ่าน</a-select-option>
                                                    </a-select>
                                                    <a-input v-model:value="create_roll_call[`${column.key}${record.index}_remark`]"
                                                        placeholder="รายละเอียดอื่นๆ" :disabled="create_roll_call[`${column.key}${record.index}_is_pass`] == 1" />
                                                    <a-button @click="openFileDialogOnClick = true" :disabled="create_roll_call[`${column.key}${record.index}_is_pass`] == 1">
                                                        <span style="font-size: 20px"
                                                            class="material-symbols-outlined">photo_camera</span>
                                                    </a-button>
                                                </a-space>
                                            </a-upload>
                                        </div>
                                    </template>
                                </template>
                            </a-table>
                        </a-collapse-panel>

                        <a-collapse-panel key="4" :header="business ? 'Truck inspection' :'Bus Inspection'">
                            <a-table :columns="[
                                {
                                    title: 'จุด',
                                    dataIndex: 'located',
                                    key: 'located',
                                    width: 50,
                                    align: 'center',
                                }, {
                                    title: 'ลำดับ',
                                    dataIndex: 'index',
                                    key: 'index',
                                    width: 20,
                                    align: 'center',
                                }, {
                                    title: 'รายการ',
                                    dataIndex: 'list',
                                    key: 'list',
                                    width: 80,
                                    align: 'start',
                                }, {
                                    title: 'รายละเอียด',
                                    dataIndex: 'details',
                                    key: 'details',
                                    width: 175,
                                    align: 'center',
                                }, {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 30,
                                    align: 'center',
                                    fixed: 'right'
                                }
                            ]" :pagination="false" :data-source="business ? truck_inspection : bus_inspection" bordered size="small"
                                :scroll="{ x: 1000 }">
                                <template #bodyCell="{ column, record,  }">
                                    <template v-if="column.key === 'id'">
                                        <a-row v-for="index, i in record.details.length" justify="center"
                                        :style="{
                                            marginBottom: record.details[i].fileList.length > 0 ? '90px' : '20px',
                                            marginTop: '10px'
                                        }">
                                            <a @click="clear_row([`bus${record.start_at + i}`],record.start_at,'bus',record.start_at + i)"><span style="font-size: 24px; color: black;"
                                                    class="material-symbols-outlined">backspace</span></a>
                                        </a-row>
                                    </template>
                                    <template v-else-if="column.key == 'index'">
                                        <a-row v-for="index, i in record.index" justify="center"
                                        :style="{
                                            marginBottom: record.details[i].fileList.length > 0 ? '100px' : '30px',
                                            marginTop: '20px'
                                        }">
                                            {{ index }}
                                        </a-row>
                                    </template>
                                    <template v-else-if="column.key == 'located'">
                                        {{ record[column.key] }}
                                    </template>
                                    <template v-else-if="column.key == 'list'">
                                        <a-row v-for="content, i in record[column.key]" justify="start" 
                                        :style="{
                                            marginBottom: record.details[i].fileList.length > 0 ? '100px' : '30px',
                                            marginTop: '20px'
                                        }">
                                            {{ content }}
                                        </a-row>
                                    </template>
                                    <template v-else-if="column.key == 'details'">
                                        <a-row v-for="content, i in record[column.key]" justify="center">
                                            <a-upload v-model:file-list="record.details[i].fileList"
                                                list-type="picture" class="upload-list-inline"
                                                :before-upload="beforeUpload"
                                                @change="upload_files($event, `bus${record.start_at + i}_photo`)" method="GET"
                                                @remove="remove_uploaded_file(`bus${record.start_at + i}_photo`)"
                                                :openFileDialogOnClick="openFileDialogOnClick">
                                                <a-space>
                                                    <a-select v-model:value="create_roll_call[`bus${(record.start_at + i)}_is_pass`]"
                                                        style="width: 100px">
                                                        <a-select-option :value="0">ไม่ผ่าน</a-select-option>
                                                        <a-select-option :value="1">ผ่าน</a-select-option>
                                                    </a-select>
                                                    <a-input v-model:value="create_roll_call[`bus${(record.start_at + i)}_remark`]"
                                                        placeholder="รายละเอียดอื่นๆ" style="width: 350px" :disabled="create_roll_call[`bus${(record.start_at + i)}_is_pass`] == 1" />
                                                    <a-button @click="openFileDialogOnClick = true" :disabled="create_roll_call[`bus${(record.start_at + i)}_is_pass`] == 1">
                                                        <span style="font-size: 20px"
                                                            class="material-symbols-outlined">photo_camera</span>
                                                    </a-button>
                                                </a-space>
                                            </a-upload>
                                        </a-row>
                                    </template>
                                </template>
                            </a-table>
                            <div style="padding: 16px; border: 5px solid #f0ecec; margin-top: 24px;">
                                <a-space direction="vertical" style="width: 100%; background-color: #f5f5f5;">
                                    <a-textarea
                                        v-model:value="create_roll_call['bus_other_remark']"
                                        placeholder="บันทึกเพิ่มเติม"
                                        :style="{ height: '100px', backgroundColor: '#f5f5f5' , border: 'none', resize: 'none', boxShadow: 'none'}"
                                    />
                                    <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 12px; margin-right: 12px;">
                                        <a-upload
                                            v-model:file-list="fileListOther"
                                            list-type="picture"
                                            class="upload-list-inline"
                                            :before-upload="beforeUpload"
                                            @change="upload_files($event, 'bus_other_photo')"
                                            method="GET"
                                            @remove="remove_uploaded_file('bus_other_photo')"
                                            :openFileDialogOnClick="openFileDialogOnClick"
                                        >
                                            <a-space>
                                                <a-button @click="openFileDialogOnClick = true" size="large">
                                                    <span class="material-symbols-outlined" style="font-size: 20px">photo_camera</span>
                                                </a-button>
                                                <a-button type="primary" size="large" @click="submit_update_other">
                                                    <template #icon><span class="material-symbols-outlined">save</span></template>
                                                    บันทึก
                                                </a-button>
                                            </a-space>
                                        </a-upload>
                                    </div>
                                </a-space>
                            </div>
                        </a-collapse-panel>

                        <a-collapse-panel key="5" header="บันทึกรายการข้อบกพร่องและการแก้ไข">
                            <a-card title="รายการข้อบกพร่องและการแก้ไข">
                                <template #extra>
                                    <a-space>
                                        <a-button style="display: flex" type="primary" size="large" @click="show_create_damage = true">
                                            <template #icon><span
                                                    class="material-symbols-outlined">Add</span></template>
                                            เพิ่มรายการข้อบกพร่อง
                                        </a-button>
                                    </a-space>
                                </template>
                                <a-table :columns="[
                                    {
                                        title: 'ลำดับ',
                                        dataIndex: 'index',
                                        key: 'index',
                                        width: 30,
                                        align: 'center',
                                    }, {
                                        title: 'รายการ',
                                        dataIndex: 'detail',
                                        key: 'detail',
                                        width: 120,
                                        align: 'start',
                                    }, {
                                        title: 'สถานะ',
                                        dataIndex: 'is_fixed',
                                        key: 'is_fixed',
                                        width: 60,
                                        align: 'center',
                                    }, {
                                        title: 'ผู้รับผิดชอบ',
                                        dataIndex: 'assignee',
                                        key: 'assignee',
                                        width: 120,
                                        align: 'center',
                                    }, {
                                        title: 'หมายเหตุ',
                                        dataIndex: 'remark',
                                        key: 'remark',
                                        width: 120,
                                        align: 'center',
                                    }, {
                                        title: 'ตัวเลือก',
                                        dataIndex: 'id',
                                        key: 'id',
                                        width: 40,
                                        align: 'center',
                                        fixed: 'right'
                                    }
                                ]" :pagination="false" :data-source="create_roll_call.damages" bordered size="small"
                                    :scroll="{ x: 1200 }">
                                    <template #bodyCell="{ column, record, index }">
                                        <template v-if="column.key === 'id'">
                                            <a @click="remove_damage(record)"><span style="font-size: 18px"
                                                    class="material-symbols-outlined">delete</span></a>
                                        </template>
                                        <template v-else-if="column.key == 'index'">
                                            {{ index + 1 }}
                                        </template>
                                        <template v-else-if="column.key == 'assignee'">
                                            <a-input v-model:value="record.assignee" placeholder="ผู้รับผิดชอบ"
                                                style="width: 200px" />
                                        </template>
                                        <template v-else-if="column.key == 'is_fixed'">
                                            <a-select v-model:value="record.is_fixed" style="width: 100px">
                                                <a-select-option :value="0">รอแก้ไข</a-select-option>
                                                <a-select-option :value="1">แก้ไขแล้ว</a-select-option>
                                            </a-select>
                                        </template>
                                        <template v-else-if="column.key == 'remark'">
                                            <a-upload list-type="picture" class="upload-list-inline"
                                                v-model:file-list="record.fileList" 
                                                :before-upload="beforeUpload"
                                                @change="upload_files_damages($event, 'damages', index)" method="GET"
                                                @remove="remove_uploaded_file_damages('damages', index)"
                                                :openFileDialogOnClick="openFileDialogOnClick">
                                                <a-space>
                                                    <a-input v-model:value="record.remark"
                                                        placeholder="รายละเอียดอื่นๆ" />
                                                    <a-button @click="openFileDialogOnClick = true">
                                                        <span style="font-size: 20px"
                                                            class="material-symbols-outlined">photo_camera</span>
                                                    </a-button>
                                                </a-space>
                                            </a-upload>
                                        </template>
                                    </template>
                                </a-table>
                            </a-card>
                        </a-collapse-panel>

                    </a-collapse>

                    <a-row justify="end">
                        <a-button type="primary" size="large" html-type="submit">
                            <template #icon><span class="material-symbols-outlined">save</span></template>
                            บันทึก
                        </a-button>
                    </a-row>
                </a-form>
            </a-card>
        </div>

        <a-modal 
            v-model:visible="show_create_damage" 
            title="เพิ่มรายการข้อบกพร่อง" 
            ok-text="บันทึก" cancel-text="ปิด" 
            @ok="save_create_damage">
            <a-form
                :model="create_damage"
                name="create_damage" autocomplete="off" layout="vertical"
            >
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="รายการข้อบกพร่องและการแก้ไข" :rules="[{ required: true, message: 'ระบุรายการข้อบกพร่องและการแก้ไข' }]">
                            <a-input v-model:value="create_damage.detail" placeholder="ระบุรายการข้อบกพร่องและการแก้ไข" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="สถานะ" :rules="[{ required: true, message: 'ระบุสถานะ' }]">
                            <a-select v-model:value="create_damage.is_fixed">
                                <a-select-option :value="0">รอแก้ไข</a-select-option>
                                <a-select-option :value="1">แก้ไขแล้ว</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="ผู้รับผิดชอบ" :rules="[{ required: true, message: 'เลือกผู้รับผิดชอบ' }]">
                            <a-select 
                                v-model:value="create_damage.assignee"
                                placeholder="เลือกผู้รับผิดชอบ"
                                show-search
                                :options="security_list.map(({ id, fullname }) => ({
                                    value: fullname,
                                    label: fullname
                                }))">
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="หมายเหตุ" :rules="[{ message: 'ระบุหมายเหตุ' }]">
                            <a-input v-model:value="create_damage.remark" placeholder="ระบุหมายเหตุ" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="รูปภาพ">
                            <a-upload list-type="picture" class="upload-list-inline"
                                v-model:file-list="create_damage.fileList" 
                                :before-upload="beforeUpload"
                                @change="upload_files_damage($event, 'photo')" method="GET"
                                @remove="remove_uploaded_file_damage('photo')"
                                accept=".png, .jpg, .jpeg"
                                :openFileDialogOnClick="openFileDialogOnClick">
                                <a-space>
                                    <a-button @click="openFileDialogOnClick = true" style="width: 100%">
                                        <span style="font-size: 20px"
                                            class="material-symbols-outlined">photo_camera</span>
                                    </a-button>
                                </a-space>
                            </a-upload>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>
    </div>

    <!-- <a-modal v-model:visible="show_export_rollcall" title="รายงาน Roll call" :footer="null">
        <template #footer>
            <a-button type="primary" @click="">บันทึก</a-button>
        </template>
    </a-modal> -->
    <a-modal v-model:visible="show_export_rollcall" title="รายงาน Roll call" :footer="null">
        <a-form :model="export_excel" layout="vertical" @finish="exportFile()">
          <a-row justify="center">
            <a-col :span="20">
              <a-form-item label="วันที่เริ่ม" :rules="[{ required: true, message: 'โปรดระบุวันที่เริ่ม' }]" name="time_start">
                  <a-date-picker style="width: 300px;" v-model:value="export_excel.time_start" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row justify="center">
            <a-col :span="20">
              <a-form-item label="วันที่สิ้นสุด" :rules="[{ required: true, message: 'โปรดระบุวันที่สิ้นสุด' }]" name="time_end">
                  <a-date-picker style="width: 300px;" v-model:value="export_excel.time_end" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row justify="center">
                <a-col :span="20">
                    <a-form-item 
                        label="รูปแบบการออกรายงาน" 
                        :rules="[{ required: true, message: 'โปรดเลือกรูปแบบการออกรายงาน' }]" 
                        name="settings">
                            <a-radio-group v-model:value="export_excel.settings" style="padding-left: 32px;">
                                <label class="radio-group-label">รูปแบบมาตรฐาน</label>
                                    <a-radio :style="radioStyle" :value="1">ทั่วไป</a-radio>
                                <label class="radio-group-label">รูปแบบพิเศษ</label>
                                    <a-radio :style="radioStyle" :value="2">ตรวจสภาพรถ</a-radio>
                                    <a-radio :style="radioStyle" :value="3">ตรวจพนักงานขับรถ</a-radio>
                                    <a-radio :style="radioStyle" :value="4">ตรวจสภาพรถและตรวจพนักงานขับรถ</a-radio>
                            </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
          <a-row justify="end">
              <a-button type="primary" html-type="submit">บันทึก</a-button>
          </a-row>
        </a-form>
    </a-modal>
     <a-modal
      v-model:visible="update_progress_modal"
      @ok="update_progress"
    >
        <template #title>
        เลือกสถานะ
        </template>
        <a-card v-if="activeKey != 2 && activeKey != null">
            <a-form :model="selected_rollcall" layout="vertical">
            <a-form-item label="สถานะ:">
                <a-select v-model:value="status_modal_id" placeholder="เลือกสถานะ">
                <a-select-option
                    v-for="{ id, name },i in status_list"
                    :key="i"
                    :value="id"
                >
                    {{ name }}
                </a-select-option>
                </a-select>
            </a-form-item>
            </a-form>
        </a-card>
    </a-modal>
</template>

<script>
import Utility from '@/utility'
import { message } from 'ant-design-vue';
import lang_th from 'ant-design-vue/es/date-picker/locale/th_TH';
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
dayjs.extend(buddhistEra);
import SystemService from '../../api/SystemService';
import RollCallService from '../../api/RollCallService';
import UserService from "../../api/UserService";
import * as xlsx from "xlsx-js-style";
import CompanyService from '../../api/CompanyService';
import StatusTag from '../../components/status_tag.vue';
import Swal from 'sweetalert2';
import SecurityService from '../../api/SecurityService';

export default {
    name: 'RollCall',
    components: { StatusTag },
    computed: {
        render_type() {
            this.clear_create_roll_call()
            if (this.$route.params.type != 'add' && this.$route.params.type != 'all') {
                this.init_edit_mode(this.$route.params.type)
                return this.$route.params.type
            } else {
                return this.$route.params.type
            }
        },
        carOptionFiltered(){
            let filterCarList = this.car_list;
            if(this.create_roll_call.car_company_id){
                filterCarList = filterCarList.filter((item)=> item.car_company_id == this.create_roll_call.car_company_id)
            }
            return filterCarList
        },
        driverOptionFiltered(){
            let filterDriverList = this.driver_list;
            if(this.create_roll_call.car_company_id){
                filterDriverList = filterDriverList.filter((item)=>item.car_company_id == this.create_roll_call.car_company_id)
            }
            // if(this.create_roll_call.car_id){
            //     let mainDriverId = this.carOptionFiltered.find((item)=>item.id == this.create_roll_call.car_id)?.driver_id;
            //     if(mainDriverId){
            //         filterDriverList = filterDriverList.filter((item)=>item.id == mainDriverId);
            //     }
            // }
            return filterDriverList
        }
    },
    data() {
        return {
            editable: Utility.get_permission_editable_with_key('roll_call'),
            activeKey: ['1'],
            businessType: null,
            business: false,
            lang_th: lang_th,
            openFileDialogOnClick: false,

            update_progress_modal: false,
            selected_rollcall: {},
            status_modal_id:null,
            descriptionOrigin: [],
            is_checked_license:0,
            require_rollcall: false,
            //Default List
            roll_call_range: null,
            search_car: null,
            search_car_company: null,
            search_plate_no: null,
            search_status: null,

            //List
            car_list: [],
            driving_license_type_list: [],
            driver_list: [],
            security_list: [],
            car_company_list: [],
            roll_call_list: [],
            status_list: [
                {id: 0 ,name:"รอตรวจสอบ"},
                {id: 1 ,name:"ผ่านการตรวจสอบ"},
                {id: 2 ,name:"พบข้อบกพร่อง"},
                {id: 3 ,name:"ห้ามใช้งาน"},
                {id: 4 ,name:"ไม่ตรวจ"},
            ],
            //Create
            preview_selected: {
                plate_no: null,
                driver_name: null,
                sub_driver_name: null,
                car_group_name: null,
            },
            create_roll_call: {
                car_company_id: null,
                car_id: null,
                issue_date: null,
                check_start: null,
                check_end: null,
                damages: [],
                driver1_is_pass: 1,
                driver2_is_pass: 1,
                sub_driver1_is_pass: 1,
                sub_driver2_is_pass: 1,
                clean1_is_pass: 1,
                clean2_is_pass: 1,
                clean3_is_pass: 1,
                health1_is_pass: 1,
                health2_is_pass: 1,
                health3_is_pass: 1,
                safe1_is_pass: 1,
                safe2_is_pass: 1,
                safe3_is_pass: 1,
                bus1_is_pass: 1,
                bus2_is_pass: 1,
                bus3_is_pass: 1,
                bus4_is_pass: 1,
                bus5_is_pass: 1,
                bus6_is_pass: 1,
                bus7_is_pass: 1,
                bus8_is_pass: 1,
                bus9_is_pass: 1,
                bus10_is_pass: 1,
                bus11_is_pass: 1,
                bus12_is_pass: 1,
                bus13_is_pass: 1,
                bus14_is_pass: 1,
                bus15_is_pass: 1,
                bus16_is_pass: 1,
                bus17_is_pass: 1,
                bus18_is_pass: 1,
                bus19_is_pass: 1,
                bus20_is_pass: 1,
                bus21_is_pass: 1,
                bus22_is_pass: 1,
                bus23_is_pass: 1,
                bus24_is_pass: 1,
                bus25_is_pass: 1,
                bus26_is_pass: 1,
                bus27_is_pass: 1,
                bus28_is_pass: 1,
                bus29_is_pass: 1,
                bus30_is_pass: 1,
                bus31_is_pass: 1,
                bus32_is_pass: 1,
                bus33_is_pass: 1,
                bus34_is_pass: 1,
                bus35_is_pass: 1,
                bus36_is_pass: 1,
                bus37_is_pass: 1,
                bus38_is_pass: 1,
                bus39_is_pass: 1,
                bus40_is_pass: 1,
                bus41_is_pass: 1,
                bus42_is_pass: 1,
                bus43_is_pass: 1,
                bus44_is_pass: 1,
                bus45_is_pass: 1,
                bus46_is_pass: 1,
                bus47_is_pass: 1,
                bus48_is_pass: 1,
                bus49_is_pass: 1,
                bus50_is_pass: 1,
                //Add default to 1
                inspector: null, 
                driver_name: null,
                main_car_service: null,
            },
            create_damage: {
                detail: null,
                is_fixed: null,
                assignee: null,
                remark: null,
                photo: null,
            },
            show_create_damage: false,

            //Edit
            driver_section: [
                {
                    index: 1,
                    detail: 'การแต่งกาย / ความพร้อมปฎฺิบัติงาน /ใบขับขี่',
                    driver: {
                        fileList: [],
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    sub_driver: {
                        fileList: [],
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    }
                }, {
                    index: 2,
                    detail: 'หน้ากากอนามัย',
                    driver: {
                        fileList: [],
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    sub_driver: {
                        fileList: [],
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    }
                }, {
                    index: 3,
                    detail: 'ปริมาณแอลกอฮอล์',
                    driver: {
                        fileList: [],
                        amount: null,
                        remark: null,
                        photo: null,
                    },
                    sub_driver: {
                        fileList: [],
                        amount: null,
                        remark: null,
                        photo: null,
                    }
                }, {
                    index: 4,
                    detail: 'อุณหภูมิร่างกาย',
                    driver: {
                        fileList: [],
                        amount: null,
                        remark: null,
                        photo: null,
                    },
                    sub_driver: {
                        fileList: [],
                        amount: null,
                        remark: null,
                        photo: null,
                    }
                }, {
                    index: 5,
                    detail: 'ความดันโลหิต',
                    driver: {
                        fileList: [],
                        amount: null,
                        bp: null,
                        remark: null,
                        photo: null,
                    },
                    sub_driver: {
                        fileList: [],
                        amount: null,
                        remark: null,
                        photo: null,
                    }
                },
            ],
            cleanliness_section: [
                {
                    index: 1,
                    clean: {
                        fileList: [],
                        title: 'ห้องคนขับ',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    health: {
                        fileList: [],
                        title: 'พ่นฆ่าเชื้อ/อบโอโซน',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    safe: {
                        fileList: [],
                        title: 'เข็มขัดนิรภัย',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    }
                }, {
                    index: 2,
                    clean: {
                        fileList: [],
                        title: 'ห้องโดยสาร',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    health: {
                        fileList: [],
                        title: 'เจลแอลกอฮอล์',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    safe: {
                        fileList: [],
                        title: 'ถังดับเพลิง/ค้อนทุบ',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    }
                }, {
                    index: 3,
                    clean: {
                        fileList: [],
                        title: 'ห้องน้ำ',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    health: {
                        fileList: [],
                        title: 'ถาดพรมน้ำยาฆ่าเชื้อ',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    },
                    safe: {
                        fileList: [],
                        title: 'ประตูฉุกเฉิน/หลังคา',
                        is_pass: 1,
                        remark: null,
                        photo: null,
                    }
                }
            ],
            truck_inspection:[
                {
                    located: 'บริเวณด้านหน้า',
                    index: ['1.', '2.', '3.','4.','5.'],
                    list: ['ระดับน้ำมันเบรก', 'ระดับน้ำยาหล่อเย็น', 'ระดับน้ำยาแผงเครื่องปรับอากาศ','ระดับน้ำหม้อน้ำ','ระดับน้ำมันเครื่อง'],
                    start_at: 1,
                    details: [
                        {
                            fileList: [],
                            is_pass_1: 1,
                            remark_1: null,
                            photo_1: null,
                        },
                        {
                            fileList: [],
                            is_pass_2: 1,
                            remark_2: null,
                            photo_2: null,
                        },
                        {
                            fileList: [],
                            is_pass_3: 1,
                            remark_3: null,
                            photo_3: null,
                        },
                        {
                            fileList: [],
                            is_pass_4: 1,
                            remark_4: null,
                            photo_4: null,
                        },
                        {
                            fileList: [],
                            is_pass_5: 1,
                            remark_5: null,
                            photo_5: null,
                        }
                    ]
                },
                 {
                    located: 'บริเวณภายในห้องโดยสารของยานพาหนะ',
                    index: ['6.', '7.', '8.','9.','10.'],
                    list: ['เครื่องบันทึกข้อมูล GPS', 'ตำแหน่งเบรกจอด', 'ตำแหน่งคันเกียร์','ตรวจสอบเครื่องยนต์','ตรวจสอบแผงควบคุม และสวิตซ์ไฟ'],
                    start_at: 6,
                    details: [
                        {
                            fileList: [],
                            is_pass_6: 1,
                            remark_6: null,
                            photo_6: null,
                        },
                        {
                            fileList: [],
                            is_pass_7: 1,
                            remark_7: null,
                            photo_7: null,
                        },
                        {
                            fileList: [],
                            is_pass_8: 1,
                            remark_8: null,
                            photo_8: null,
                        },
                        {
                            fileList: [],
                            is_pass_9: 1,
                            remark_9: null,
                            photo_9: null,
                        },
                        {
                            fileList: [],
                            is_pass_10: 1,
                            remark_10: null,
                            photo_10: null,
                        }
                    ]
                },
                {
                    located: 'บริเวณด้านหน้าขวาล้อหลังของยานพาหนะ',
                    index: ['11.', '12.', '13.', '14.', '15.'],
                    list: ['ตำแหน่งล้อ และกระทะล้อ', 'ช่องเก็บสัมภาระ', 'ตำแหน่งถังลม', 'อุปกรณ์ยึดตัวหางพ่วง', 'อุปกรณ์แบตเตอรี่'],
                    start_at: 11,
                    details: [
                        { fileList: [], is_pass_11: 1, remark_11: null, photo_11: null },
                        { fileList: [], is_pass_12: 1, remark_12: null, photo_12: null },
                        { fileList: [], is_pass_13: 1, remark_13: null, photo_13: null },
                        { fileList: [], is_pass_14: 1, remark_14: null, photo_14: null },
                        { fileList: [], is_pass_15: 1, remark_15: null, photo_15: null },
                    ]
                },
                {
                    located: 'บริเวณด้านขวาล้อหลังของหางลาก (Trailer)',
                    index: ['16.', '17.', '18.', '19.', '20.'],
                    list: ['อุปกรณ์หางลาก', 'โครงสร้างตัวถังรถหางลาก', 'การผูกรัดสินค้า', 'ไฟส่องสว่าง', 'สภาพยางรถ'],
                    start_at: 16,
                    details: [
                        { fileList: [], is_pass_16: 1, remark_16: null, photo_16: null },
                        { fileList: [], is_pass_17: 1, remark_17: null, photo_17: null },
                        { fileList: [], is_pass_18: 1, remark_18: null, photo_18: null },
                        { fileList: [], is_pass_19: 1, remark_19: null, photo_19: null },
                        { fileList: [], is_pass_20: 1, remark_20: null, photo_20: null },
                    ]
                },
                {
                    located: 'บริเวณด้านหลังของหางลาก (Trailer)',
                    index: ['21.', '22.', '23.', '24.', '25.'],
                    list: ['ไฟส่องสว่าง', 'ป้ายสัญญาณต่างๆ', 'การผูกรัดสินค้า', 'ความมั่นคงของสินค้า', 'อุปกรณ์ช่วยขึ้นลงสินค้าด้านท้าย'],
                    start_at: 21,
                    details: [
                        { fileList: [], is_pass_21: 1, remark_21: null, photo_21: null },
                        { fileList: [], is_pass_22: 1, remark_22: null, photo_22: null },
                        { fileList: [], is_pass_23: 1, remark_23: null, photo_23: null },
                        { fileList: [], is_pass_24: 1, remark_24: null, photo_24: null },
                        { fileList: [], is_pass_25: 1, remark_25: null, photo_25: null },
                    ]
                },
                {
                    located: 'บริเวณด้านซ้ายล้อหลังของหางลาก (Trailer)',
                    index: ['26.', '27.', '28.', '29.', '30.'],
                    list: ['อุปกรณ์หางลาก', 'โครงสร้างตัวถังหางรถ', 'การผูกรัดสินค้า', 'ไฟส่องสว่าง', 'สภาพยางรถ'],
                    start_at: 26,
                    details: [
                        { fileList: [], is_pass_26: 1, remark_26: null, photo_26: null },
                        { fileList: [], is_pass_27: 1, remark_27: null, photo_27: null },
                        { fileList: [], is_pass_28: 1, remark_28: null, photo_28: null },
                        { fileList: [], is_pass_29: 1, remark_29: null, photo_29: null },
                        { fileList: [], is_pass_30: 1, remark_30: null, photo_30: null },
                    ]
                },
                {
                    located: 'บริเวณด้านซ้ายล้อหลังของยานพาหนะ',
                    index: ['31.', '32.', '33.', '34.', '35.'],
                    list: ['ตำแหน่งล้อ และกระทะล้อ', 'ช่องเก็บสัมภาระ', 'ตำแหน่งถังลม', 'อุปกรณ์ตัวยึดหางพ่วง', 'อุปกรณ์แบตเตอรี่'],
                    start_at: 31,
                    details: [
                        { fileList: [], is_pass_31: 1, remark_31: null, photo_31: null },
                        { fileList: [], is_pass_32: 1, remark_32: null, photo_32: null },
                        { fileList: [], is_pass_33: 1, remark_33: null, photo_33: null },
                        { fileList: [], is_pass_34: 1, remark_34: null, photo_34: null },
                        { fileList: [], is_pass_35: 1, remark_35: null, photo_35: null },
                    ]
                },
                {
                    located: 'บริเวณด้านซ้ายล้อหน้าของยานพาหนะ',
                    index: ['36.', '37.', '38.', '39.', '40.'],
                    list: ['ตำแหน่งล้อ และกระทะล้อ', 'ช่องเก็บสัมภาระ', 'ตำแหน่งถังลม', 'อุปกรณ์ยืดหางพ่วง', 'กล่องน้ำยาฉีดกระจก'],
                    start_at: 36,
                    details: [
                        { fileList: [], is_pass_36: 1, remark_36: null, photo_36: null },
                        { fileList: [], is_pass_37: 1, remark_37: null, photo_37: null },
                        { fileList: [], is_pass_38: 1, remark_38: null, photo_38: null },
                        { fileList: [], is_pass_39: 1, remark_39: null, photo_39: null },
                        { fileList: [], is_pass_40: 1, remark_40: null, photo_40: null },
                    ]
                },
                {
                    located: 'บริเวณด้านหน้าช่วงระยะด้านบนของยานพาหนะ',
                    index: ['41.', '42.', '43.', '44.', '45.'],
                    list: ['กระจกด้านหน้า', 'ไฟส่องสว่าง', 'ป้ายสัญญาณ', 'ไฟสัญญาณ', 'แผ่นป้ายต่างๆ'],
                    start_at: 41,
                    details: [
                        { fileList: [], is_pass_41: 1, remark_41: null, photo_41: null },
                        { fileList: [], is_pass_42: 1, remark_42: null, photo_42: null },
                        { fileList: [], is_pass_43: 1, remark_43: null, photo_43: null },
                        { fileList: [], is_pass_44: 1, remark_44: null, photo_44: null },
                        { fileList: [], is_pass_45: 1, remark_45: null, photo_45: null },
                    ]
                },
                {
                    located: 'ภายในห้องโดยสาร',
                    index: ['46.', '47.', '48.', '49.', '50.'],
                    list: ['เบาะนั่ง', 'แผงควบคุม', 'ปุ่มควบคุมสวิตซ์ไฟบริเวณคอพวงมาลัย', 'เข็มขัดนิรภัย', 'ทดสอบระยะเบรก'],
                    start_at: 46,
                    details: [
                        { fileList: [], is_pass_46: 1, remark_46: null, photo_46: null },
                        { fileList: [], is_pass_47: 1, remark_47: null, photo_47: null },
                        { fileList: [], is_pass_48: 1, remark_48: null, photo_48: null },
                        { fileList: [], is_pass_49: 1, remark_49: null, photo_49: null },
                        { fileList: [], is_pass_50: 1, remark_50: null, photo_50: null },
                    ]
                }
            ],
            bus_inspection: [
                {
                    located: 'หน้า',
                    index: ['1.', '2.', '3.'],
                    list: ['ตัวถัง / กระจกหน้า / กระจกมองข้าง', 'ระบบไฟหน้ารถ', 'ป้ายหน้ารถ'],
                    start_at: 1,
                    details: [
                        {
                            fileList: [],
                            is_pass_1: 1,
                            remark_1: null,
                            photo_1: null,
                        },
                        {
                            fileList: [],
                            is_pass_2: 1,
                            remark_2: null,
                            photo_2: null,
                        },
                        {
                            fileList: [],
                            is_pass_3: 1,
                            remark_3: null,
                            photo_3: null,
                        }
                    ]
                }, {
                    located: 'ขวา',
                    index: ['4.', '5.'],
                    list: ['ตัวถัง / กระจกด้านขวา', 'ล้อยาง / ลมยางขวา'],
                    start_at: 4,
                    details: [
                        {
                            fileList: [],
                            is_pass_4: 1,
                            remark_4: null,
                            photo_4: null,
                        },
                        {
                            fileList: [],
                            is_pass_5: 1,
                            remark_5: null,
                            photo_5: null,
                        }
                    ]
                }, {
                    located: 'หลัง',
                    index: ['6.', '7.'],
                    list: ['ระบบไฟท้าย', 'เสียงผิดปกติเครื่องยนต์'],
                    start_at: 6,
                    details: [
                        {
                            fileList: [],
                            is_pass_6: 1,
                            remark_6: null,
                            photo_6: null,
                        },
                        {
                            fileList: [],
                            is_pass_7: 1,
                            remark_7: null,
                            photo_7: null,
                        }
                    ]
                }, {
                    located: 'ซ้าย',
                    index: ['8.', '9.', '10.'],
                    list: ['ตัวถัง / กระจกด้านซ้าย', 'ล้อยาง  ลมยางซ้าย', 'เก๊ะสัมภาระ / ประตูผู้โดยสาร'],
                    start_at: 8,
                    details: [
                        {
                            fileList: [],
                            is_pass_8: 1,
                            remark_8: null,
                            photo_8: null,
                        },
                        {
                            fileList: [],
                            is_pass_9: 1,
                            remark_9: null,
                            photo_9: null,
                        },
                        {
                            fileList: [],
                            is_pass_10: 1,
                            remark_10: null,
                            photo_10: null,
                        }
                    ]
                }, {
                    located: 'ห้องคนขับ',
                    index: ['11.', '12.', '13.'],
                    list: ['คอนโซลหน้า / หน้าปัดรถ', 'เครื่องรูดบัตร / อุปกร์ GPS', 'วิทยุสื่อสาร'],
                    start_at: 11,
                    details: [
                        {
                            fileList: [],
                            is_pass_11: 1,
                            remark_11: null,
                            photo_11: null,
                        },
                        {
                            fileList: [],
                            is_pass_12: 1,
                            remark_12: null,
                            photo_12: null,
                        },
                        {
                            fileList: [],
                            is_pass_13: 1,
                            remark_13: null,
                            photo_13: null,
                        }
                    ]
                }, {
                    located: 'ภายใน',
                    index: ['14.', '15.', '16.'],
                    list: ['เครื่องเสียง / ทีวี / VTR', 'ระบบแสงสว่างภายใน', 'สภาพที่นั่ง และสิ่งอำนวยความสะดวก'],
                    start_at: 14,
                    details: [
                        {
                            fileList: [],
                            is_pass_14: 1,
                            remark_14: null,
                            photo_14: null,
                        },
                        {
                            fileList: [],
                            is_pass_15: 1,
                            remark_15: null,
                            photo_15: null,
                        },
                        {
                            fileList: [],
                            is_pass_16: 1,
                            remark_16: null,
                            photo_16: null,
                        }
                    ]
                }
            ],
            fileListOther: [],
            show_export_rollcall: false,
            selected_date_filter: "issue_date",
            export_excel: {
                time_start: null,
                time_end: null,
                settings: null
            },
            radioStyle: {
            display: 'block',
            marginBottom: '8px',
            },
        }
    },
    methods: {
        printCheck(data){
            console.log("SSSS",data);
        },
        statusRollCall(record){
            if (record.status == 0) {
                return { txt: "รอตรวจสอบ", color: "#E3B23C" };
            }else if(record.status == 1) {
                return { txt: "ผ่านการตรวจสอบ", color: "#389E0D" };
            }else if(record.status == 2) {
                return { txt: "พบข้อบกพร่อง", color: "#FF5400" };
            }else if(record.status == 3) {
                return { txt: "ห้ามใช้งาน", color: "#313030" };   
            }else if(record.status == 4) {
                return { txt: "ไม่ตรวจ", color: "#E33C3C" };
            }else{
                return { txt: "ผ่านการตรวจสอบ", color: "#389E0D" };
            }
        },
        clearSubData(){
            this.create_roll_call.car_id = null;
            this.create_roll_call.driver_name = null;
            this.create_roll_call.driver_license_no = null;
            this.create_roll_call.driving_license_type_id = null;
            this.is_checked_license = 0;
        },
        licenseCheck(value){
            const [firstname, lastname] = value.split(' ')
            let checkLicenseNo = this.driverOptionFiltered.find((item)=> item.firstname == firstname && item.lastname == lastname)?.driver_license_no
            if(checkLicenseNo){
                this.is_checked_license = checkLicenseNo ? 1 : 0;
                this.create_roll_call.driver_license_no = checkLicenseNo;
                this.create_roll_call.driving_license_type_id = this.driverOptionFiltered.find((item)=> item.firstname == firstname && item.lastname == lastname)?.driving_license_type_id
            }
        },
        show_update_progress(id) {
            this.update_progress_modal = true;
            this.selected_rollcall = this.roll_call_list.find((rollcall) => rollcall.id === id);
            this.status_modal_id = this.selected_rollcall.status;
        },
        async update_progress() {
            await SystemService.update_all("RollCall", { data: { status: this.status_modal_id } }, this.selected_rollcall.id).then(async (res) => {
            if (res) {
                this.update_progress_modal = false;
                await this.init_options();
                Swal.fire("อัพเดทเรียบร้อย", "อัพเดทสถานะเรียบร้อย", "success");
            }
            });
        },
        initMap(target) {
            if (window.google && window.google.maps) {
                const input = this.$refs[target].$el;
                const options = {
                types: ['establishment'],
                componentRestrictions: { country: 'th' },
                };

                // สร้าง Google Autocomplete instance
                const googleMap = new google.maps.places.Autocomplete(input, options);

                // Listener สำหรับการเลือกสถานที่
                googleMap.addListener('place_changed', () => {
                const place = googleMap.getPlace(); 
                if (place && place.name) {
                    this.create_roll_call[target] = place.name;
                }
                else if(target === "origin"){
                    this.originDescription(place)
                }
                });
            }
        },
        originDescription(place){
            const lat = place?.geometry?.location.lat();
            const lng = place?.geometry?.location.lng();
            this.descriptionOrigin = [JSON.stringify({ lat, lng })];
        },
        async exportFile() {
            this.$message.loading({ content: "กำลังโหลด...", key: "loading" });
            const time_start = dayjs(this.export_excel.time_start).format('YYYY-MM-DD');
            const time_end = dayjs(this.export_excel.time_end).format('YYYY-MM-DD');
            const headersColumn = [];
            if(this.export_excel.settings == 1){
                headersColumn.push(
                    { header: "วันที่", key: "issue_date" }, 
                    { header: "เวลาตรวจ", key: "issue_date_time" }, 
                    { header: "รถที่รับตรวจ", key: "car_check" }, 
                    { header: "ชื่อพนักงานขับรถ", key: "driver_name" }, 
                    { header: "ชื่อพนักงานบริการประจำรถ", key: "main_car_service" }, 
                    { header: "การแต่งกาย / ความพร้อมปฎิบัติงาน / ใบขับขี่", key: "driver1_is_pass" }, 
                    { header: "หน้ากากอนามัย", key: "driver2_is_pass" }, 
                    { header: "ปริมาณแอลกอฮอล์", key: "driver3_amount" },
                    { header: "อุณหภูมิร่างกาย", key: "driver4_amount"}, 
                    { header: "ความดันโลหิต", key: "driver5_amount" }, 
                    { header: "ห้องคนขับ", key: "clean1_is_pass" }, 
                    { header: "ห้องโดยสาร", key: "clean2_is_pass" },
                    { header: "ห้องน้ำ", key: "clean3_is_pass" },
                    { header: "พ่นฆ่าเชื้อ/อบโอโซน", key: "health1_is_pass" },
                    { header: "เจลแอลกอฮอล์", key: "health2_is_pass" },
                    { header: "ถาดพรมน้ำฆ่าเชื้อ", key: "health3_is_pass" },
                    { header: "เข็มขัดนิรภัย", key: "safe1_is_pass" }, 
                    { header: "ถังดับเพลิง/ค้อนทุบ", key: "safe2_is_pass" }, 
                    { header: "ประตูฉุกเฉิน/หลังคา", key: "safe3_is_pass" }, 
                    { header: "ตัวถัง / กระจกหน้า / กระจกมองข้าง", key: "bus1_is_pass" }, 
                    { header: "ระบบไฟหน้ารถ", key: "bus2_is_pass" }, 
                    { header: "ป้ายหน้ารถ", key: "bus3_is_pass" }, 
                    { header: "ตัวถัง / กระจกด้านขวา", key: "bus4_is_pass" }, 
                    { header: "ล้อยาง / ลมยางขวา", key: "bus5_is_pass" }, 
                    { header: "ระบบไฟท้าย", key: "bus6_is_pass" }, 
                    { header: "เสียงผิดปกติเครื่องยนต์", key: "bus7_is_pass" }, 
                    { header: "ตัวถัง / กระจกด้านซ้าย", key: "bus8_is_pass" }, 
                    { header: "ล้อยาง ลมยางซ้าย", key: "bus9_is_pass" }, 
                    { header: "เก๊ะสัมภาระ / ประตูผู้โดยสาร", key: "bus10_is_pass" }, 
                    { header: "คอนโซลหน้า / หน้าปัดรถ", key: "bus11_is_pass" }, 
                    { header: "เครื่องรูดบัตร / อุปกรณ์ GPS", key: "bus12_is_pass" }, 
                    { header: "วิทยุสื่อสาร", key: "bus13_is_pass" }, 
                    { header: "เครื่องเสียง / ทีวี / VTR", key: "bus14_is_pass" }, 
                    { header: "ระบบแสงสว่างภายใน", key: "bus15_is_pass" }, 
                    { header: "สภาพที่นั่ง และสิ่งอำนวยความสะดวก", key: "bus16_is_pass" }, 
                    // { header: "Bus Inspection", key: "col20" }, 
                    { header: "รายการข้อบกพร่องและการแก้ไข", key: "damages" }, 
                    { header: "ชื่อผู้ตรวจ", key: "inspector" },
                )
                let result = await RollCallService.getRollcallByTimeStartAndTimeEnd(time_start, time_end);
                result = result.data;
                await this.exportToExcel(result, headersColumn, `รายงาน Rollcall ทั่วไป.xlsx`);
                headersColumn.length = 0;
            } else if (this.export_excel.settings == 2){
                headersColumn.push(
                    { header: "วันที่", key: "issue_date" }, 
                    { header: "เวลาตรวจ", key: "issue_date_time" }, 
                    { header: "รถที่รับตรวจ", key: "car_check" }, 
                    { header: "ชื่อพนักงานขับรถ", key: "driver_name" }, 
                    { header: "ชื่อพนักงานบริการประจำรถ", key: "main_car_service" },
                    { header: "ห้องคนขับ", key: "clean1_is_pass" }, 
                    { header: "ห้องโดยสาร", key: "clean2_is_pass" },
                    { header: "ห้องน้ำ", key: "clean3_is_pass" },
                    { header: "พ่นฆ่าเชื้อ/อบโอโซน", key: "health1_is_pass" },
                    { header: "เจลแอลกอฮอล์", key: "health2_is_pass" },
                    { header: "ถาดพรมน้ำฆ่าเชื้อ", key: "health3_is_pass" },
                    { header: "เข็มขัดนิรภัย", key: "safe1_is_pass" }, 
                    { header: "ถังดับเพลิง/ค้อนทุบ", key: "safe2_is_pass" }, 
                    { header: "ประตูฉุกเฉิน/หลังคา", key: "safe3_is_pass" }, 
                    { header: "ตัวถัง / กระจกหน้า / กระจกมองข้าง", key: "bus1_is_pass" }, 
                    { header: "ระบบไฟหน้ารถ", key: "bus2_is_pass" }, 
                    { header: "ป้ายหน้ารถ", key: "bus3_is_pass" }, 
                    { header: "ตัวถัง / กระจกด้านขวา", key: "bus4_is_pass" }, 
                    { header: "ล้อยาง / ลมยางขวา", key: "bus5_is_pass" }, 
                    { header: "ระบบไฟท้าย", key: "bus6_is_pass" }, 
                    { header: "เสียงผิดปกติเครื่องยนต์", key: "bus7_is_pass" }, 
                    { header: "ตัวถัง / กระจกด้านซ้าย", key: "bus8_is_pass" }, 
                    { header: "ล้อยาง ลมยางซ้าย", key: "bus9_is_pass" }, 
                    { header: "เก๊ะสัมภาระ / ประตูผู้โดยสาร", key: "bus10_is_pass" }, 
                    { header: "คอนโซลหน้า / หน้าปัดรถ", key: "bus11_is_pass" }, 
                    { header: "เครื่องรูดบัตร / อุปกรณ์ GPS", key: "bus12_is_pass" }, 
                    { header: "วิทยุสื่อสาร", key: "bus13_is_pass" }, 
                    { header: "เครื่องเสียง / ทีวี / VTR", key: "bus14_is_pass" }, 
                    { header: "ระบบแสงสว่างภายใน", key: "bus15_is_pass" }, 
                    { header: "สภาพที่นั่ง และสิ่งอำนวยความสะดวก", key: "bus16_is_pass" }, 
                    // { header: "Bus Inspection", key: "col20" }, 
                    { header: "รายการข้อบกพร่องและการแก้ไข", key: "damages" }, 
                    { header: "ชื่อผู้ตรวจ", key: "inspector" }, 
                )
                let result = await RollCallService.getCarRollcallByTimeStartAndTimeEnd(time_start, time_end);
                result = result.data;
                await this.exportToExcel(result, headersColumn, `รายงาน Rollcall สภาพรถ.xlsx`);
            } else if (this.export_excel.settings == 3){
                headersColumn.push(
                    { header: "วันที่", key: "issue_date" }, 
                    { header: "เวลาตรวจ", key: "issue_date_time" }, 
                    { header: "รถที่รับตรวจ", key: "car_check" }, 
                    { header: "ชื่อพนักงานขับรถ", key: "driver_name" }, 
                    { header: "ชื่อพนักงานบริการประจำรถ", key: "main_car_service" },
                    { header: "การแต่งกาย / ความพร้อมปฎิบัติงาน / ใบขับขี่", key: "driver1_is_pass" }, 
                    { header: "หน้ากากอนามัย", key: "driver2_is_pass" }, 
                    { header: "ปริมาณแอลกอฮอล์", key: "driver3_amount" },
                    { header: "อุณหภูมิร่างกาย", key: "driver4_amount"}, 
                    { header: "ความดันโลหิต", key: "driver5_amount" },
                    { header: "ชื่อผู้ตรวจ", key: "inspector" },
                )
                let result = await RollCallService.getDriverRollcallByTimeStartAndTimeEnd(time_start, time_end);
                result = result.data;
                await this.exportToExcel(result, headersColumn, `รายงาน Rollcall พนักงานขับรถ.xlsx`);
            } else if (this.export_excel.settings == 4){
                headersColumn.push(
                    { header: "วันที่", key: "issue_date" }, 
                    { header: "เวลาตรวจ", key: "issue_date_time" }, 
                    { header: "รถที่รับตรวจ", key: "car_check" }, 
                    { header: "ชื่อพนักงานขับรถ", key: "driver_name" }, 
                    { header: "ชื่อพนักงานบริการประจำรถ", key: "main_car_service" },
                    { header: "ห้องคนขับ", key: "clean1_is_pass" }, 
                    { header: "ห้องโดยสาร", key: "clean2_is_pass" },
                    { header: "ห้องน้ำ", key: "clean3_is_pass" },
                    { header: "พ่นฆ่าเชื้อ/อบโอโซน", key: "health1_is_pass" },
                    { header: "เจลแอลกอฮอล์", key: "health2_is_pass" },
                    { header: "ถาดพรมน้ำฆ่าเชื้อ", key: "health3_is_pass" },
                    { header: "เข็มขัดนิรภัย", key: "safe1_is_pass" }, 
                    { header: "ถังดับเพลิง/ค้อนทุบ", key: "safe2_is_pass" }, 
                    { header: "ประตูฉุกเฉิน/หลังคา", key: "safe3_is_pass" }, 
                    { header: "ตัวถัง / กระจกหน้า / กระจกมองข้าง", key: "bus1_is_pass" }, 
                    { header: "ระบบไฟหน้ารถ", key: "bus2_is_pass" }, 
                    { header: "ป้ายหน้ารถ", key: "bus3_is_pass" }, 
                    { header: "ตัวถัง / กระจกด้านขวา", key: "bus4_is_pass" }, 
                    { header: "ล้อยาง / ลมยางขวา", key: "bus5_is_pass" }, 
                    { header: "ระบบไฟท้าย", key: "bus6_is_pass" }, 
                    { header: "เสียงผิดปกติเครื่องยนต์", key: "bus7_is_pass" }, 
                    { header: "ตัวถัง / กระจกด้านซ้าย", key: "bus8_is_pass" }, 
                    { header: "ล้อยาง ลมยางซ้าย", key: "bus9_is_pass" }, 
                    { header: "เก๊ะสัมภาระ / ประตูผู้โดยสาร", key: "bus10_is_pass" }, 
                    { header: "คอนโซลหน้า / หน้าปัดรถ", key: "bus11_is_pass" }, 
                    { header: "เครื่องรูดบัตร / อุปกรณ์ GPS", key: "bus12_is_pass" }, 
                    { header: "วิทยุสื่อสาร", key: "bus13_is_pass" }, 
                    { header: "เครื่องเสียง / ทีวี / VTR", key: "bus14_is_pass" }, 
                    { header: "ระบบแสงสว่างภายใน", key: "bus15_is_pass" }, 
                    { header: "สภาพที่นั่ง และสิ่งอำนวยความสะดวก", key: "bus16_is_pass" }, 
                    // { header: "Bus Inspection", key: "col20" }, 
                    { header: "รายการข้อบกพร่องและการแก้ไข", key: "damages" }, 
                    { header: "ชื่อผู้ตรวจ", key: "inspector" }, 
                )
                let result = await RollCallService.getCarRollcallByTimeStartAndTimeEnd(time_start, time_end);
                result = result.data;
                await this.exportToExcel(result, headersColumn, `รายงาน Rollcall สภาพรถ.xlsx`)
                headersColumn.length = 0;
                headersColumn.push(
                    { header: "วันที่", key: "issue_date" }, 
                    { header: "เวลาตรวจ", key: "issue_date_time" }, 
                    { header: "รถที่รับตรวจ", key: "car_check" }, 
                    { header: "ชื่อพนักงานขับรถ", key: "driver_name" }, 
                    { header: "ชื่อพนักงานบริการประจำรถ", key: "main_car_service" },
                    { header: "การแต่งกาย / ความพร้อมปฎิบัติงาน / ใบขับขี่", key: "driver1_is_pass" }, 
                    { header: "หน้ากากอนามัย", key: "driver2_is_pass" }, 
                    { header: "ปริมาณแอลกอฮอล์", key: "driver3_amount" },
                    { header: "อุณหภูมิร่างกาย", key: "driver4_amount"}, 
                    { header: "ความดันโลหิต", key: "driver5_amount" },
                    { header: "ชื่อผู้ตรวจ", key: "inspector" }, 
                )
                result = await RollCallService.getDriverRollcallByTimeStartAndTimeEnd(time_start, time_end);
                result = result.data;
                await this.exportToExcel(result, headersColumn, `รายงาน Rollcall พนักงานขับรถ.xlsx`)
                headersColumn.length = 0;
            }
        },
        async exportToExcel(data, headersColumn, fileName){
            const workBook = xlsx.utils.book_new();
            const workSheet = xlsx.utils.json_to_sheet(data, { header: headersColumn.map(h => h.key) });
            const lastRow = data.length + 1; // +1 for headers

            // Add headers manually because json_to_sheet doesn't automatically add headers
            xlsx.utils.sheet_add_aoa(workSheet, [headersColumn.map(h => h.header)], { origin: 'A1' });
                    
            // Style the headers
            headersColumn.forEach((header, index) => {
                let cell = workSheet[xlsx.utils.encode_cell({ c: index, r: 0 })];
                cell.s = {
                font: { bold: true },
                fill: { fgColor: { rgb: "BCD6AC" } },
                border: { bottom: { style: "thin" } , right: { style: "thin" } , left: { style: "thin" } , top: { style: "thin" } },
                alignment: { horizontal: "center" }
                };
            });

            // Style the data rows
            for (let row = 1; row < lastRow; row++) {
                for (let col = 0; col < headersColumn.length; col++) {
                    const cellAddress = xlsx.utils.encode_cell({ c: col, r: row });
                    let cell = workSheet[cellAddress];
                    if (!cell) {
                        cell = { v: "" };
                        workSheet[cellAddress] = cell;
                    }
                    cell.s = {
                        border: { bottom: { style: "thin" }, right: { style: "thin" }, left: { style: "thin" }, top: { style: "thin" } },
                        alignment: { horizontal: "center" }
                    };
                }
            }

            // Adjust the column width as needed
            workSheet['!cols'] = headersColumn.map(() => ({ wch: 32 }));

            xlsx.utils.book_append_sheet(workBook, workSheet, "Report");
            xlsx.writeFile(workBook, fileName);
            this.$message.success({ content: "โหลดข้อมูลสำเร็จ", key: "loading" });
        },
        remove_rollcall(id) {
            message.loading({ content: 'กำลังลบ...', key: 'updatable'})
            SystemService.delete_all('RollCall', id)
                .then(() => {
                    message.success({ content: 'ลบสำเร็จ', key: 'updatable', duration: 2 })
                    this.init_options()
                })
                .catch(err => {
                    message.error({ content: 'ลบไม่สำเร็จ', key: 'updatable', duration: 2 })
                })
        },
        render_date(date) {
            return dayjs(date).format('DD/MM/YYYY')
        },
        clear_search() {
            this.search_status = null;
            this.search_car_company = null;
            this.search_car = null;
            this.roll_call_range = [];
            this.selected_date_filter = null;
        },
        async clear_create_roll_call() {
            this.create_roll_call = {
                car_company_id: null,
                car_id: null,
                issue_date: null,
                check_start: null,
                check_end: null,
                damages: [],
                driver1_is_pass: 1,
                driver2_is_pass: 1,
                sub_driver1_is_pass: 1,
                sub_driver2_is_pass: 1,
                clean1_is_pass: 1,
                clean2_is_pass: 1,
                clean3_is_pass: 1,
                health1_is_pass: 1,
                health2_is_pass: 1,
                health3_is_pass: 1,
                safe1_is_pass: 1,
                safe2_is_pass: 1,
                safe3_is_pass: 1,
                bus1_is_pass: 1,
                bus2_is_pass: 1,
                bus3_is_pass: 1,
                bus4_is_pass: 1,
                bus5_is_pass: 1,
                bus6_is_pass: 1,
                bus7_is_pass: 1,
                bus8_is_pass: 1,
                bus9_is_pass: 1,
                bus10_is_pass: 1,
                bus11_is_pass: 1,
                bus12_is_pass: 1,
                bus13_is_pass: 1,
                bus14_is_pass: 1,
                bus15_is_pass: 1,
                bus16_is_pass: 1,
                bus17_is_pass: 1,
                bus18_is_pass: 1,
                bus19_is_pass: 1,
                bus20_is_pass: 1,
                bus21_is_pass: 1,
                bus22_is_pass: 1,
                bus23_is_pass: 1,
                bus24_is_pass: 1,
                bus25_is_pass: 1,
                bus26_is_pass: 1,
                bus27_is_pass: 1,
                bus28_is_pass: 1,
                bus29_is_pass: 1,
                bus30_is_pass: 1,
                bus31_is_pass: 1,
                bus32_is_pass: 1,
                bus33_is_pass: 1,
                bus34_is_pass: 1,
                bus35_is_pass: 1,
                bus36_is_pass: 1,
                bus37_is_pass: 1,
                bus38_is_pass: 1,
                bus39_is_pass: 1,
                bus40_is_pass: 1,
                bus41_is_pass: 1,
                bus42_is_pass: 1,
                bus43_is_pass: 1,
                bus44_is_pass: 1,
                bus45_is_pass: 1,
                bus46_is_pass: 1,
                bus47_is_pass: 1,
                bus48_is_pass: 1,
                bus49_is_pass: 1,
                bus50_is_pass: 1,
                //Add default to 1
                inspector: null, 
                driver_name: null,
                main_car_service: null,
            },
            this.is_checked_license = 0;
            this.bus_inspection.forEach(section => {
                section.details.forEach(detail => {
                    detail.fileList = [];
                });
            });
            this.truck_inspection.forEach(section => {
                section.details.forEach(detail => {
                    detail.fileList = [];
                });
            });
            this.driver_section.forEach(section => {
                section.driver.fileList = [];
                section.sub_driver.fileList = [];
            });
            this.cleanliness_section.forEach(section => {
                section.clean.fileList = [];
                section.health.fileList = [];
                section.safe.fileList = [];
            });
            this.fileListOther = [];
        },
        remove_damage(e) {
            message.loading({ content: 'กำลังลบ...', key: 'updatable'})
            const { id } = e
            if (id) {
                SystemService.delete_all('Damage', id)
                    .then(() => {
                        message.success({ content: 'ลบสำเร็จ', key: 'updatable', duration: 2 })
                        this.create_roll_call.damages.splice(e, 1)
                    })
            } else {
                message.success({ content: 'ลบสำเร็จ', key: 'updatable', duration: 2 })
                this.create_roll_call.damages.splice(e, 1)
            }
        },
        save_create_damage() {
            this.create_roll_call.damages.push(this.create_damage)
            this.create_damage = {
                detail: null,
                is_fixed: null,
                assignee: null,
                remark: null,
                photo: null,
            }
            this.show_create_damage = false;
            console.log("cscascx",this.create_roll_call)
        },
        submit_update_other() {
            message.loading({ content: 'กำลังบันทึก...', key: 'updatable'})
            const result = this.create_roll_call
            result.company_id = JSON.parse(localStorage.getItem('companyData')).id

            if (result.id) {
                SystemService.update_all('RollCall', { data: result }, result.id)
                    .then(() => {
                        message.success({ content: 'บันทึกสำเร็จ', key: 'updatable', duration: 2 })
                    })
                    .catch((err) => {
                        console.log(err);
                        message.error('บันทึกไม่สำเร็จ')
                    })
            }
            else{
                message.success({ content: 'บันทึกสำเร็จ', key: 'updatable', duration: 2 })
            }
        },
        async submit_create_roll_call() {
            message.loading({ content: 'กำลังบันทึก...', key: 'updatable'})
            const now = dayjs()
            this.create_roll_call.check_end = now
            const result = this.create_roll_call
            // result.issue_date = result.issue_date.format('DD/MM/YYYY HH:mm:ss')
            // result.check_start = result.check_start.format('DD/MM/YYYY HH:mm:ss')
            // result.check_end = result.check_end.format('DD/MM/YYYY HH:mm:ss')
            result.company_id = JSON.parse(localStorage.getItem('companyData')).id
            if(result?.damages?.length > 0){
                result.damages.forEach(d => {
                    delete d.fileList
                })
            }
            
            if (result.id) {
                const isPassValues = Object.keys(result)
                .filter(key => key.endsWith('_is_pass'))
                .map(key => result[key]);
                const anyFailed = isPassValues.some(val => val === 0);
                if(result?.damages?.some((item)=>item.is_fixed == 0)){
                    result.status = 2;
                }else if(!anyFailed){
                    result.status = 1;
                }else{
                    result.status = 0;
                }
                try {
                    await SystemService.update_all('RollCall', { data: result }, result.id);
                    if(result.damages.length > 1){
                        const damageList = result.damages.filter((item)=>item?.id != null);
                        await RollCallService.updateDamages(damageList);
                    }

                    message.success({ content: 'บันทึกสำเร็จ', key: 'updatable', duration: 2 });

                    this.$router.push('/app/roll-call/all');
                    this.clear_create_roll_call();
                    this.init_options();

                } catch (err) {
                    console.log(err);
                    message.error('บันทึกไม่สำเร็จ');
                }
            } else {
                result.status = 0;
                RollCallService.createRollcall(result)
                    .then(() => {
                        message.success({ content: 'บันทึกสำเร็จ', key: 'updatable', duration: 2 })
                        this.$router.push('/app/roll-call/all')
                        this.clear_create_roll_call()
                        this.init_options()
                    })
                    .catch((err) => {
                        console.log(err);
                        message.error('บันทึกไม่สำเร็จ')
                    })
            }
        },
        submit_create_roll_call_failed() {
            message.error('กรุณากรอกข้อมูลให้ครบถ้วน')
        },
        filtered_list(array) {
            return array.filter((e) => {
                let pass = true;

                // 1. ตรวจสถานะ
                if (this.search_status != null) {
                const done = e.pass_all != null;
                pass = pass && (this.search_status == 1 ? done : !done);
                }

                // 2. ตรวจบริษัทรถ
                if (this.search_car_company) {
                pass = pass && e.car_company?.fullname?.includes(this.search_car_company);
                }

                // 3. ตรวจป้ายทะเบียนรถ
                if (this.search_car) {
                pass = pass && (e.car?.plate_no?.includes(this.search_car) || e.driver_name?.includes(this.search_car) || e.car?.car_no?.includes(this.search_car));
                }

                // 4. ตรวจช่วงวันที่ (roll call)
                if (this.roll_call_range && this.roll_call_range.length === 2) {
                const time_start = dayjs(this.roll_call_range[0]).startOf('day');
                const time_end = dayjs(this.roll_call_range[1]).endOf('day');
                const dateToCheck =
                    this.selected_date_filter === 'issue_date'
                    ? dayjs(e.issue_date)
                    : this.selected_date_filter === 'check_end'
                        ? dayjs(e.check_end)
                        : null;

                if (dateToCheck) {
                    pass = pass && dateToCheck.isBetween(time_start, time_end, 'day', '[]');
                }
                }

                return pass;
            });
        },
        async upload_files(e, target) {
            this.getBase64(e.file.originFileObj, target)
            return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
        },
        async remove_uploaded_file(key) {
            this.create_roll_call[key] = ''
        },
        async getBase64(file, target) {
            try {
                const vue = this.create_roll_call
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    vue[target] = reader.result
                };
            } catch (err) {
                console.log(err);
            }
        },
        async upload_files_damage(e, target) {
            this.getBase64_damage(e.file.originFileObj, target)
            return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
        },
        async getBase64_damage(file, target) {
            try {
                const vue = this.create_damage
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    vue[target] = reader.result
                };
            } catch (err) {
                console.log(err);
            }
        },
        async remove_uploaded_file_damage(key) {
            this.create_damage[key] = ''
        },
         async upload_files_damages(e, target,idx) {
            this.getBase64_damages(e.file.originFileObj, target,idx)
            return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
        },
        async getBase64_damages(file, target, idx) {
            try {
                const vue = this.create_roll_call
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    vue[target][idx].photo = reader.result
                };
            } catch (err) {
                console.log(err);
            }
        },
        async remove_uploaded_file_damages(key,idx) {
            this.create_roll_call[key][idx].photo = ''
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                message.error('Image must smaller than 1MB!');
            }
            return isLt2M;
        },
        select_car(value) {
            const { plate_no, driver, car_group } = this.car_list.find((car) => car.id === value)
            this.preview_selected.plate_no = plate_no
            // this.preview_selected.driver_name = driver ? `${driver.firstname} ${driver.lastname}` : ''
            this.create_roll_call.driver_name = null;
            this.preview_selected.car_group_name = car_group ? car_group.name : ''
            const mainDriver = this.car_list?.find((item)=>item.id == value)?.driver;
            this.create_roll_call.driver_license_no = null;
            this.create_roll_call.driving_license_type_id = null;
            this.is_checked_license = 0;
            if(mainDriver){
                this.create_roll_call.driver_name = mainDriver.firstname + " " + mainDriver.lastname;
                this.licenseCheck(this.create_roll_call.driver_name);
            }
        },
        clear_row(target_list,id,type,bus_id) {
            target_list.forEach((target) => {
                const prefix = target + "_";
                for (var key in this.create_roll_call) {
                    if (key.includes(prefix)) {
                        this.create_roll_call[key] = ''
                    }
                }
            })
            if(type == 'driver'){
                this.driver_section[id-1].driver.fileList = [];
                this.driver_section[id-1].sub_driver.fileList = [];
            }else if(type == 'clean'){
                this.cleanliness_section[id-1].clean.fileList = [];
                this.cleanliness_section[id-1].health.fileList = [];
                this.cleanliness_section[id-1].safe.fileList = [];
            }else if(type == 'bus'){
                if(this.business){
                    const indexBus = this.truck_inspection.findIndex((item)=>item.start_at == id);
                    const numberBus = this.truck_inspection[indexBus].index.findIndex((item)=>item == bus_id);
                    console.log("csacasc",indexBus,numberBus)
                    this.truck_inspection[indexBus].details[numberBus].fileList = []
                }else{
                    const indexBus = this.bus_inspection.findIndex((item)=>item.start_at == id);
                    const numberBus = this.bus_inspection[indexBus].index.findIndex((item)=>item == bus_id);
                    this.bus_inspection[indexBus].details[numberBus].fileList = []
                }
            }else if(type == 'truck'){
                const indexBus = this.truck_inspection.findIndex((item)=>item.start_at == id);
                const numberBus = this.truck_inspection[indexBus].index.findIndex((item)=>item == bus_id);
                this.truck_inspection[indexBus].details[numberBus].fileList = []
            }            
        },
        async init_businessType() {
            this.businessType = await CompanyService.getBusinessId(this.car_company_list[0].company_id)
            if (this.businessType.data === 2 || this.businessType.data === 3){
                this.business = true
            }
        },
        async init_options() {
            await SystemService.get_all('CarCompany').then((res) => {
                this.car_company_list = res;
            })
            this.init_businessType()
            await SystemService.get_all('Car').then((res) => {
                this.car_list = res;
            })
            await SystemService.get_all('DrivingLicenseType').then((res)=>{
                this.driving_license_type_list = res;
            })
            await SystemService.get_all('Driver').then((res)=>{
                this.driver_list = res;
            })
            await SystemService.get_all('RollCall').then((res) => {
                this.roll_call_list = res.sort((a,b) => new Date(b.issue_date) - new Date(a.issue_date));
            })
            await SecurityService.getSecurityByCompany().then((res)=>{
                this.security_list = res;
            })
            this.require_rollcall = JSON.parse(localStorage.getItem('companyData')).require_rollcall == 1
        },
        async init_edit_mode(id) {
            
            this.create_roll_call = await SystemService.get_id('RollCall', id)
            const { check_start, check_end, issue_date } = this.create_roll_call
            this.create_roll_call.check_start = check_start? dayjs(check_start) : null
            this.create_roll_call.check_end = check_end? dayjs(check_end) : null
            this.create_roll_call.issue_date = issue_date? dayjs(issue_date) : null
            this.is_checked_license = this.create_roll_call.driver_license_no ? 1 : 0;
            if(this.create_roll_call?.bus_other_photo){
                this.fileListOther.push({ 
                                uid: `photo_other_1`,
                                name: '',
                                status: 'done',
                                url: this.create_roll_call?.bus_other_photo
                            });
            }
            for (var key in this.create_roll_call) {
                if (key.includes('photo') && this.create_roll_call[key] && key != 'bus_other_photo') {
                    this.photo_parser(key, this.create_roll_call[key])
                }

                if (key == 'damages') {
                    this.create_roll_call[key].forEach((damage, index) => {
                        damage.fileList = []
                        if(damage.photo != null){
                            damage.fileList.push({ 
                                uid: `photo_${index+1}`,
                                name: '',
                                status: 'done',
                                url: damage.photo
                            })
                        }
                    })
                }
            }
        },
        photo_parser(key, value) {
            // Get number from string
            const index = key.match(/\d+/)[0]
            // Replace number + '_photo' with empty string
            const target = key.replace(/\d+_photo/, '')

            const rules = {
                key: target,
                index: index,
            }

            const defaultKey = {
                truck: 'truck_inspection',
                bus: 'bus_inspection',
                sub_driver: 'driver_section',
                driver: 'driver_section',
                clean: 'cleanliness_section',
                health: 'cleanliness_section',
                safe: 'cleanliness_section'
            }

            // Helper to add file to a section
            const addFile = (sectionKey) => {
                const location = this[sectionKey].find((e) => {
                    if (typeof e.index === 'number') {
                        return e.index == rules.index
                    } else {
                        return e.index.map(i => i.replace('.', '')).includes(rules.index)
                    }
                })

                if (location) {
                    if (location[rules.key]) {
                        location[rules.key].fileList.push({ 
                            uid: `photo_${rules.index+1}`,
                            name: '',
                            status: 'done',
                            url: value
                        })
                    } else {
                        const e = location.index.map(i => i.replace('.', '')).indexOf(rules.index)
                        location.details[e].fileList.push({ 
                            uid: `photo_${rules.index+1}`,
                            name: '',
                            status: 'done',
                            url: value
                        })
                    }
                }
            }

            // Add to original section
            addFile(defaultKey[rules.key])

            // If key is bus, also add to truck
            if (rules.key === 'bus') {
                addFile(defaultKey['truck'])
            }
        },
        async init_mode() {
            if (this.render_type != 'add' && this.render_type != 'all') {
                
            } else {
                this.booking_files = []
                await this.init_options()
            }
        },
    },
    watch: {
        openFileDialogOnClick: function (val) {
            if (val) {
                setTimeout(() => {
                    this.openFileDialogOnClick = false
                }, 100)
            }
        },
        require_rollcall(newVal) {
            if (newVal != null) {
                const { company_id } = JSON.parse(localStorage.getItem('user_profile'))
                SystemService.update_all('Company', { data: { require_rollcall: newVal } }, company_id)
                    .then(res => {
                        const original = JSON.parse(localStorage.getItem('companyData'))
                        original.require_rollcall = newVal
                        localStorage.setItem('companyData', JSON.stringify(original))
                    })
            }
        },
        user_profile_username : function(newVal) {
            this.create_roll_call.inspector = newVal;
        }
    },
    async mounted() {
        this.clear_create_roll_call();
        await this.init_mode()
        await this.init_options()
    },
}
</script>
<style scoped>

.ant-upload-list-picture::-webkit-scrollbar {
  opacity: 1;
}
.ant-row {
    margin: 5px 0
}

.ant-col-12,
.ant-col-24,
.ant-col-4,
.ant-col-8,
.ant-col-6 {
    padding: 0 4px
}

.ant-select,
.ant-picker {
    width: 100%
}

.ant-col {
    width: 100%
}

.ant-form-item {
    margin-bottom: 0;
}

.quotation-container {
    padding: 15px;
    height: 100vh;
}

.blue-card {
    background-color: #1890ff;
    color: white;
    border-radius: 5px;
    margin: 5px
}

.red-card {
    background-color: #a2a2a2;
    color: white;
    border-radius: 5px;
    margin: 5px
}
</style>